import {ContentContext} from "../../../../../utils/contexts";

const { withStyles, ButtonGroup, Button } = window.Material;
const { KeyboardArrowLeft, KeyboardArrowRight } = window.MaterialIcons;

const styles = {
  button: {
    padding: '0.5rem',
  },
  group: {
    marginLeft: '0.5rem',
  },
};

class PaginationActions extends React.PureComponent {
  handlePage = newPage => {
    const { setProperty, fetchContent, searchMode, doSearch, searchQuery, pageSize } = this.context;

    setProperty("page", newPage);

    if (searchMode) {
      doSearch(searchQuery, undefined, (newPage - 1) * pageSize, pageSize);
    } else {
      fetchContent(undefined, newPage);
    }
  };

  render() {
    const { classes } = this.props;
    const { page, total, pageSize, loadingContent } = this.context;

    return (
      <ButtonGroup classes={{ root: classes.group }}>
        <Button
          classes={{ root: classes.button }}
          disabled={page === 1 || loadingContent}
          onClick={() => this.handlePage(page - 1)}
          id="paginationBackBtn"
        >
          <KeyboardArrowLeft fontSize="small" />
        </Button>
        <Button
          classes={{ root: classes.button }}
          disabled={page === Math.ceil(total / pageSize) || loadingContent}
          onClick={() => this.handlePage(page + 1)}
          id="paginationForwardBtn"
        >
          <KeyboardArrowRight fontSize="small" />
        </Button>
      </ButtonGroup>
    );
  }
}

PaginationActions.contextType = ContentContext;

export default withStyles(styles)(PaginationActions);
